import { render, staticRenderFns } from "./VideoBrowser.vue?vue&type=template&id=54e8cdae&"
import script from "./VideoBrowser.vue?vue&type=script&lang=js&"
export * from "./VideoBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports